import service_management from '@/services/service_management'
import vuex_authentication from '@/store/modules/vuex_authentication'
import service_explorers from '@/services/global/service_explorers'
import store from '@/store'

const fields = {
  ID: 'id',
  PROCESS_CODE: 'process_code',
  PROCESS_NAME: 'process_name',
  MASTER_ACCOUNT_NAME: 'master_account_name',
  MASTER_ACCOUNT_CODE: 'master_account_code',
  USERNAME: 'username',
  SUBACCOUNT_NAME: 'subaccount_name',
  SUBACCOUNT_CODE: 'subaccount_code',
  CREATION_TIMESTAMP: 'creation_timestamp',
  STATUS: 'status',
  VERSION: 'version',
  ENVIRONMENT: 'environment',
  USER_OPERATION: 'user_id'
}
const GLOBAL_FOLDER_NAME = 'CHECKLISTS'
const FOLDER_NAME = 'CHECKLIST'
export const MODEL_NAME = `CertySign_Checklist_v{version}`


async function getVersions(processCode) {
  const options = {
    rpp: 999,
    sortDesc: [true],
    page: 1,
    sortBy: [fields.CREATION_TIMESTAMP]
  }
  const data = await service_explorers.find('app-center/pkc/checklists', Object.values(fields), {
    [fields.PROCESS_CODE]: processCode
  }, options)
  return data.results
}

async function createModelVersion(processCode) {
  const userLoggedId = store.state[vuex_authentication.constants.NAMESPACE][vuex_authentication.constants.S_ID]
  return service_management.createChecklist(userLoggedId, processCode)
}

async function addComment(checkListMetadata, comment, action = 'comment') {

  checkListMetadata.info.timeline.unshift({
    user: store.state[vuex_authentication.constants.NAMESPACE][vuex_authentication.constants.S_USERNAME],
    timestamp: new Date().getTime(),
    action: action,
    comment: comment
  })

  return checkListMetadata
}

async function updateStatus(checklistId, newStatus) {
  await service_management.updateChecklist(checklistId, {
    [fields.STATUS]: newStatus
  })
}

export const statuses = [
  {
    id: 'draft',
    name: 'Borrador',
    color: '#c9a718',
    checkedText: 'Cumplimentado',
    icon: 'description',
    paragraph: 'El checklist se encuentra en estado de borrador. Puede editarlo, realizar las modificaciones necesarias y enviarlo para su revisión.'
  },
  {
    id: 'pending_approval',
    name: 'Pendiente de aprobación',
    action: 'Validar',
    color: '#157bbb',
    checkedText: 'Aprobado',
    icon: 'content_paste_search',
    paragraph: 'El checklist se encuentra en estado de pendiente de aprobación. Puede revisar el checklist y enviarlo para su aprobación.'
  },
  {
    id: 'completed',
    name: 'Completado',
    color: '#31b232',
    action: 'Aprobar',
    checkedText: 'Completado',
    icon: 'description',
    paragraph: 'El checklist se encuentra en estado de completado. No puede realizar más modificaciones.'
  }

]

export default {
  fields,
  FOLDER_NAME,
  GLOBAL_FOLDER_NAME,
  statuses,
  createModelVersion,
  getVersions,
  addComment,
  updateStatus
}